// extracted by mini-css-extract-plugin
module.exports = {"baseDropdownMenu":"BaseDropdownMenu_baseDropdownMenu_8_aq2","rwdTop":"BaseDropdownMenu_rwdTop_2UF2_"};